Vue.component("legend-blog-list", {

    template: `<div>
      <template v-if="!listIsLoading">
        <carousel-legend v-if="articleList.length > 0"
          :items-per-page="itemsPerPage"
          :items-per-page-xs="itemsPerPageXs"
          :items-per-page-sm="itemsPerPageSm"
          :items-per-page-md="itemsPerPageMd"
          :items-per-page-lg="itemsPerPageLg">
          <template slot="items" v-for="(article,index) in articleList">
            <legend-blog-post :article="article"></legend-blog-post>
          </template>
        </carousel-legend>
        <slot v-else name="NoArticles"></slot>
      </template>
      <div v-else>
        <loading-animation class="w-100"></loading-animation>
      </div>
    </div>
    `,

    props: {
        categoryId: {
            type: Number,
            default: 0
        },
        showDummy: {
            type: Boolean,
            default: false
        },
        maxItems: {
            type: Number,
            default: 6
        },
        itemsPerPage: {
            type: Number,
            default: 4
        },
        itemsPerPageXs: {
            type: Number,
            default: 1
        },
        itemsPerPageSm: {
            type: Number,
            default: 2
        },
        itemsPerPageMd: {
            type: Number,
            default: 3
        },
        itemsPerPageLg: {
            type: Number,
            default: 4
        }
    },

    created()
    {
        this.setFilters();
        this.loadFirstPage();
    },

    data()
    {
        return {
            page: 1,
            filtersString: "",
            listIsLoading: true,
            articleList: []
        };
    },

    methods: {
        loadFirstPage()
        {
            this.getPosts(this.page);
        },

        getPosts(page)
        {
            const _this = this;

            $.ajax({
                type: "GET",
                url: "/rest/blogplugin/articles?page=" + Number(page) + "&itemsPerPage=" + Number(this.maxItems) + this.filtersString,
                contentType: "application/json; charset=utf-8",
                success: function(data)
                {
                    $.each(data.entries, function(key, value)
                    {
                        _this.articleList.push(value);
                    });

                    if (data.entries.length === 0)
                    {
                        $(".blog-search-input").focus();
                    }
                },
                complete: function()
                {
                    _this.listIsLoading = false;
                }
            });
        },

        setFilters()
        {
            this.filtersString = "";
            if (this.categoryId)
            {
                this.filtersString += "&categoryId=" + this.categoryId;
            }
        }
    }
});

Vue.component("legend-blog-post", {

    template: `<div class="row">
        <div class="col-12">
            <a :href="article.urls.postUrl" class="blog-post-image-wrap" v-if="article.data.images.preview">
                <lazy-img v-if="article.data.images.preview.path"
                        class="blog-post-image blog-post-image-fullwidth"
                        :image-url="article.data.images.preview.path"
                        :alt="article.data.post.title">
                    </lazy-img>
            </a>
        </div>

        <div class="col-12">
            <div class="blog-post-content">
                <div class="blog-post-header">
                    <h4 class="blog-post-title">
                        <a :href="article.urls.postUrl">\${ article.data.post.title }</a>
                    </h4>
                    <p class="blog-details">
                        <template v-if="article.data.user">
                            <i class="fa fa-user" aria-hidden="true"></i>
                            <a :href="article.urls.landingUrl + '/search/' + article.data.user.realName">
                                <span class="blog-detail blog-detail-author">
                                    <span class="blog-detail-author-name">\${ article.data.user.realName }</span>
                                </span>
                            </a>
                        </template>
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        <span class="blog-detail blog-detail-date">\${ article.data.post.publishedAt | moment("DD MMM, YYYY") }</span>
                    </p>
                </div>
                <p class="blog-post-shortdescription">\${ article.data.post.shortDescription }</p>
            </div>
        </div>
    </div>`,

    props: {
        article: {
            type: Object,
            required: true
        }
    }
});
